<template>
    <page-loading v-if="loading"></page-loading>
    <form-container v-else>
        <page-header v-if="props.contactId" class="mb-6 lg:mb-12">
            <template v-slot:subtitle>
                <a href="/contacts" class="no-underline! text-sky-600! text-base font-normal">
                    <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                    All Contacts
                </a>
            </template>

            <slot name="header">{{ fullName }}</slot>
        </page-header>

        <div
            :class="{
                'grid grid-cols-12 items-start': props.contactId,
            }"
        >
            <page-sidebar
                v-if="props.contactId"
                appearance="nested"
                :links="
                    [
                        {
                            href: `/contacts/${props.contactId}`,
                            label: 'Details',
                            patchMatcher: match([`/contacts/${props.contactId}`, `/contacts/${props.contactId}/view`]),
                        },
                        logsLinks,
                    ].filter((link) => Boolean(link))
                "
            ></page-sidebar>
            <slot></slot>
        </div>
    </form-container>
</template>

<script setup>
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { computed, onMounted } from 'vue';
import { match } from 'path-to-regexp';
import { useContactDetails } from './useContactDetails';
import FormContainer from '~/components/general/FormContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';

const props = defineProps({
    groupId: {
        type: String,
    },
    contactId: {
        type: Number,
        required: false,
    },
});

const { fullName, loading, mount } = useContactDetails();

onMounted(() => {
    mount(props.contactId, props.groupId);
});

const logsLinks = computed(() => {
    if (props.groupId) {
        return;
    }

    const links = [
        {
            label: 'Messages',
            href: `/contacts/${props.contactId}/messages`,
        },
        {
            label: 'Segments',
            href: `/contacts/${props.contactId}/segments`,
        },
        {
            label: 'Campaigns',
            href: `/contacts/${props.contactId}/campaigns`,
        },
        {
            label: 'Custom Attributes',
            href: `/contacts/${props.contactId}/custom-attributes`,
        },
        {
            label: 'Subscriptions',
            href: `/contacts/${props.contactId}/subscriptions`,
        },
        {
            label: 'Promotions',
            href: `/contacts/${props.contactId}/promotions`,
        },
    ];

    return {
        label: 'Logs',
        links: links,
    };
});
</script>
